import { render, staticRenderFns } from "./microbialLoadOfAV.vue?vue&type=template&id=67521fca&scoped=true&"
import script from "./microbialLoadOfAV.vue?vue&type=script&lang=js&"
export * from "./microbialLoadOfAV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67521fca",
  null
  
)

export default component.exports